interface LocalRobotDataState {
  webappHasUnsyncedChanges: boolean;
  hasCompletedFullDataSync: boolean;
}

export const isLocalRobotDataState = (input: any): input is LocalRobotDataState => {
  return 'webappHasUnsyncedChanges' in input;
};

export default LocalRobotDataState;
